module.exports = __webpack_public_path__ + "static/media/свободные веса - скамья для пресса.24bad238.jpg";